import React from 'react';
import { BaseDialog } from '@/components';
import { BaseButton } from '@/components/uiKit/Button';
import { useTranslation } from 'react-i18next';

export interface ConfirmationDialogProps {
  isOpened: boolean;
  onOpenChange?: (open: boolean) => void;
  onDontSaveAction: () => void;
  onConfirmAction: () => void;
  onCancelAction: () => void;
}

export const ConfirmationDialog = ({
  isOpened,
  onOpenChange,
  onDontSaveAction,
  onConfirmAction,
  onCancelAction,
}: ConfirmationDialogProps) => {
  const { t } = useTranslation();
  return (
    <div>
      <BaseDialog
        open={isOpened}
        className="w-[400px]"
        title={t('confirmationDialog.unsavedChanges')}
        content={
          <div>
            <div className="py-4">{t('confirmationDialog.discardMessage')}</div>
            <div className="flex justify-between gap-2">
              <BaseButton variant="ghost" size="lg" onClick={onCancelAction}>
                {t('confirmationDialog.cancel')}
              </BaseButton>
              <BaseButton variant="outline" size="lg" onClick={onDontSaveAction}>
                {t('confirmationDialog.dontSave')}
              </BaseButton>
              <BaseButton variant="filled" size="lg" onClick={onConfirmAction}>
                {t('confirmationDialog.saveAndExit')}
              </BaseButton>
            </div>
          </div>
        }
        onOpenChange={onOpenChange}
      />
    </div>
  );
};
